import React, { SetStateAction, useContext, useEffect, useState } from "react";
import "../style/Sold.scss";

import { auth, db } from "../config";
import {
  collection,
  getDoc,
  doc,
  query,
  where,
  getDocs,
  onSnapshot,
} from "firebase/firestore";
import ExpiredContext from "../context/Context";
import Product from "./Product";

interface SoldProps {}

const Sold: React.FC<SoldProps> = () => {
  type CategoryType = "" | "LONGFILL" | "PREMIX" | "LIQUID";

  interface IProductsArr {
    EAN: number;
    name: string;
    piece: number;
    month?: number;
    year?: number;
    category: CategoryType;
    user: string;
    id: string;
    receiptIssued: boolean;
    price?: number;
  }

  const context = useContext(ExpiredContext);
  const { search, category, savedSoldArr, setSavedSoldArr } = context;

  const [productsArr, setProductsArr] = useState<IProductsArr[]>([]);
  const [products, setProducts] = useState<any>([]);

  const getData = async () => {
    try {
      const user = auth.currentUser;

      if (user) {
        const collectionRef = collection(db, "sold");
        const querySnapshot = await getDocs(
          query(collectionRef, where("user", "==", user.uid))
        );
        const productsData: IProductsArr[] = [];

        querySnapshot.forEach((doc) => {
          if (doc.exists()) {
            const productData = doc.data() as IProductsArr;

            const productWithId: IProductsArr = {
              ...productData,
              id: doc.id,
            };

            productsData.push(productWithId);
          } else {
            console.error("The document does not exist.");
          }
        });

        const sortedProducts = [...productsData].sort((a, b) => {
          if (!a.receiptIssued) return -1;
          if (!b.receiptIssued) return 1;
          return 0;
        });
        setSavedSoldArr(sortedProducts);
        setProductsArr(sortedProducts);
      } else {
        console.log("Brak użytkownika");
      }
    } catch (error) {
      console.error("Download data failed: ", error);
    }
  };

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
      if (user) {
        if (savedSoldArr === null) getData();
        else setProductsArr(savedSoldArr);
      } else {
        console.log("Brak użytkownika");
      }
    });

    const unsubscribeSnapshot = onSnapshot(collection(db, "product"), () => {
      if (auth.currentUser) {
        if (savedSoldArr === null) getData();
        else setProductsArr(savedSoldArr);
      }
    });

    return () => {
      unsubscribeAuth();
      unsubscribeSnapshot();
    };
  });

  const getSearchProducts = () => {
    const filteredProducts = productsArr.filter((item: IProductsArr) => {
      const lowerCaseName = item.name.toLowerCase();
      const lowerCaseCategory = item.category.toLowerCase();
      const lowerCaseEAN = item.EAN ? item.EAN.toString().toLowerCase() : "";

      return (
        (lowerCaseName.includes(search.toLowerCase()) &&
          (category === "" ||
            lowerCaseCategory.includes(category.toLowerCase()))) ||
        lowerCaseEAN.includes(search.toLowerCase())
      );
    });

    const temporaryProducts = filteredProducts.map((item: IProductsArr) => {
      return (
        <Product
          key={item.id}
          name={item.name}
          pieces={item.piece}
          month={item.month}
          year={item.year}
          id={item.id}
          receiptIssued={item.receiptIssued}
          price={item.price}
          sold={true}
        />
      );
    });

    setProducts(temporaryProducts);
  };

  const getProducts = () => {
    const filteredProducts = productsArr.filter((item: IProductsArr) => {
      return (
        item.name.toLowerCase().includes(search.toLowerCase()) &&
        (category === "" ||
          item.category.toLowerCase().includes(category.toLowerCase()))
      );
    });

    const temporaryProducts = filteredProducts.map((item: IProductsArr) => {
      return (
        <Product
          key={item.id}
          name={item.name}
          pieces={item.piece}
          month={item.month}
          year={item.year}
          id={item.id}
          receiptIssued={item.receiptIssued}
          price={item.price}
          sold={true}
        />
      );
    });

    setProducts(temporaryProducts);
  };

  useEffect(() => {
    if (search == "") getProducts();
    else getSearchProducts();
  }, [productsArr, search, category]);

  return (
    <div className="Sold">
      <span className="title">Sprzedane: {productsArr.length}</span>
      {products}
    </div>
  );
};

export default Sold;
